
// This file is auto-generated by fetchTokensFromFigma.ts
export default {
  "color": {
    "text": {
      "primary": {
        "Base": "#1a1a1aff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "primaryInverted": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "secondary": {
        "Base": "#000000b2",
        "Matas": "#0d0f13c2",
        "Kicks": "#0d0f13c2"
      },
      "secondaryInverted": {
        "Base": "#ffffff99",
        "Matas": "#ffffff99",
        "Kicks": "#ffffff99"
      },
      "brand": {
        "Base": "#084ec5ff",
        "Matas": "#002643ff",
        "Kicks": "#161616ff"
      },
      "brandInverted": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "accent": {
        "Base": "#d8dbe5ff",
        "Matas": "#0064feff",
        "Kicks": "#127173ff"
      },
      "onAccent": {
        "Base": "#1a1a1aff",
        "Matas": "#ffffffff",
        "Kicks": "#161616ff"
      },
      "highlight": {
        "Base": "#d8dbe5ff",
        "Matas": "#c5dfffff",
        "Kicks": "#9cf3ebff"
      },
      "onHighlight": {
        "Base": "#1a1a1aff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "disabled": {
        "Base": "#00000066",
        "Matas": "#131d3c66",
        "Kicks": "#131d3c66"
      },
      "disabledInverted": {
        "Base": "#ffffff4d",
        "Matas": "#ffffff66",
        "Kicks": "#ffffff66"
      },
      "link": {
        "Base": "#000000ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "inactive": {
        "Base": "#00000066",
        "Matas": "#131d3c66",
        "Kicks": "#131d3c66"
      },
      "active": {
        "Base": "#084ec5ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "linkInverted": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "linkHover": {
        "Base": "#00000080",
        "Matas": "#0e183680",
        "Kicks": "#0e183680"
      },
      "linkHoverInverted": {
        "Base": "#ffffff80",
        "Matas": "#ffffff80",
        "Kicks": "#ffffff80"
      },
      "info": {
        "Base": "#878b99ff",
        "Matas": "#878b99ff",
        "Kicks": "#878b99ff"
      },
      "onInfoLight": {
        "Base": "#676973ff",
        "Matas": "#676973ff",
        "Kicks": "#676973ff"
      },
      "onInfo": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "sale": {
        "Base": "#b71e1eff",
        "Matas": "#bd0229ff",
        "Kicks": "#d11616ff"
      },
      "success": {
        "Base": "#32852dff",
        "Matas": "#32852dff",
        "Kicks": "#32852dff"
      },
      "onSuccessLight": {
        "Base": "#275724ff",
        "Matas": "#275724ff",
        "Kicks": "#275724ff"
      },
      "onSuccess": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "error": {
        "Base": "#da2828ff",
        "Matas": "#da2828ff",
        "Kicks": "#da2828ff"
      },
      "onErrorLight": {
        "Base": "#7e1e1eff",
        "Matas": "#981c1cff",
        "Kicks": "#981c1cff"
      },
      "onError": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "warning": {
        "Base": "#ae600eff",
        "Matas": "#ae600eff",
        "Kicks": "#ae600eff"
      },
      "onWarningLight": {
        "Base": "#803a13ff",
        "Matas": "#803a13ff",
        "Kicks": "#803a13ff"
      },
      "onWarning": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      }
    },
    "icon": {
      "primary": {
        "Base": "#000000ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "primaryInverted": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "secondary": {
        "Base": "#00000080",
        "Matas": "#0d0f13c2",
        "Kicks": "#0d0f13c2"
      },
      "secondaryInverted": {
        "Base": "#ffffff99",
        "Matas": "#ffffff99",
        "Kicks": "#ffffff99"
      },
      "brand": {
        "Base": "#084ec5ff",
        "Matas": "#002643ff",
        "Kicks": "#161616ff"
      },
      "brandInverted": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "disabled": {
        "Base": "#0000004d",
        "Matas": "#3c4d8133",
        "Kicks": "#3c4d8133"
      },
      "disabledInverted": {
        "Base": "#ffffff4d",
        "Matas": "#ffffff66",
        "Kicks": "#ffffff66"
      },
      "inactive": {
        "Base": "#00000066",
        "Matas": "#00000066",
        "Kicks": "#00000066"
      },
      "active": {
        "Base": "#084ec5ff",
        "Matas": "#002643ff",
        "Kicks": "#161616ff"
      },
      "hover": {
        "Base": "#0d469bff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "focus": {
        "Base": "#0e2b5dff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "favorite": {
        "Base": "#000000ff",
        "Matas": "#f90935ff",
        "Kicks": "#ff0000ff"
      },
      "accent": {
        "Base": "#a1a5b2ff",
        "Matas": "#0064feff",
        "Kicks": "#127173ff"
      },
      "onAccent": {
        "Base": "#1a1a1aff",
        "Matas": "#ffffffff",
        "Kicks": "#161616ff"
      },
      "onHighlight": {
        "Base": "#1a1a1aff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "info": {
        "Base": "#878b99ff",
        "Matas": "#878b99ff",
        "Kicks": "#878b99ff"
      },
      "onInfoLight": {
        "Base": "#676973ff",
        "Matas": "#676973ff",
        "Kicks": "#676973ff"
      },
      "onInfo": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "success": {
        "Base": "#32852dff",
        "Matas": "#32852dff",
        "Kicks": "#32852dff"
      },
      "onSuccessLight": {
        "Base": "#275724ff",
        "Matas": "#275724ff",
        "Kicks": "#275724ff"
      },
      "onSuccess": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "error": {
        "Base": "#da2828ff",
        "Matas": "#da2828ff",
        "Kicks": "#da2828ff"
      },
      "onErrorLight": {
        "Base": "#981c1cff",
        "Matas": "#981c1cff",
        "Kicks": "#981c1cff"
      },
      "onError": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "warning": {
        "Base": "#ae600eff",
        "Matas": "#ae600eff",
        "Kicks": "#ae600eff"
      },
      "onWarningLight": {
        "Base": "#803a13ff",
        "Matas": "#803a13ff",
        "Kicks": "#803a13ff"
      },
      "onWarning": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      }
    },
    "border": {
      "primary": {
        "Base": "#00000080",
        "Matas": "#0e183680",
        "Kicks": "#0e183680"
      },
      "primaryInverted": {
        "Base": "#ffffff66",
        "Matas": "#ffffff66",
        "Kicks": "#ffffff66"
      },
      "secondary": {
        "Base": "#00000033",
        "Matas": "#3c4d8133",
        "Kicks": "#3c4d8133"
      },
      "secondaryInverted": {
        "Base": "#ffffff33",
        "Matas": "#ffffff33",
        "Kicks": "#ffffff33"
      },
      "tertiary": {
        "Base": "#0000001a",
        "Matas": "#344d981a",
        "Kicks": "#344d981a"
      },
      "tertiaryInverted": {
        "Base": "#ffffff1a",
        "Matas": "#ffffff1a",
        "Kicks": "#ffffff1a"
      },
      "brand": {
        "Base": "#084ec5ff",
        "Matas": "#002643ff",
        "Kicks": "#161616ff"
      },
      "focus": {
        "Base": "#000000ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "hover": {
        "Base": "#000000ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "disabled": {
        "Base": "#00000033",
        "Matas": "#3c4d8133",
        "Kicks": "#3c4d8133"
      },
      "focusRing": {
        "Base": "#000000ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "focusRingInverted": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "info": {
        "Base": "#878b99ff",
        "Matas": "#878b99ff",
        "Kicks": "#878b99ff"
      },
      "success": {
        "Base": "#32852dff",
        "Matas": "#32852dff",
        "Kicks": "#32852dff"
      },
      "error": {
        "Base": "#da2828ff",
        "Matas": "#da2828ff",
        "Kicks": "#da2828ff"
      },
      "warning": {
        "Base": "#ae600eff",
        "Matas": "#ae600eff",
        "Kicks": "#ae600eff"
      },
      "default": {
        "Base": "#0000004d",
        "Matas": "#0000004d",
        "Kicks": "#0000004d"
      },
      "active": {
        "Base": "#1a1a1aff",
        "Kicks": "#1a1a1aff"
      }
    },
    "bg": {
      "primary": {
        "Base": "#f7f8fbff",
        "Matas": "#f7f8fbff",
        "Kicks": "#f7f8fbff"
      },
      "secondary": {
        "Base": "#f7f8fbff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "tertiary": {
        "Base": "#0000001a",
        "Matas": "#344d981a",
        "Kicks": "#344d981a"
      },
      "inverse": {
        "Base": "#1a1a1aff",
        "Matas": "#1a1a1aff",
        "Kicks": "#1a1a1aff"
      },
      "brand": {
        "Base": "#084ec5ff",
        "Matas": "#002643ff",
        "Kicks": "#161616ff"
      },
      "disabled": {
        "Base": "#0000001a",
        "Matas": "#0026431a",
        "Kicks": "#344d981a"
      },
      "overlay": {
        "Base": "#0000004d",
        "Matas": "#0000004d",
        "Kicks": "#0000004d"
      },
      "overlayInverse": {
        "Base": "#ffffff33",
        "Matas": "#ffffff33",
        "Kicks": "#ffffff33"
      },
      "inactive": {
        "Base": "#ffffffff",
        "Matas": "#ffffffff",
        "Kicks": "#ffffffff"
      },
      "active": {
        "Base": "#0000000d",
        "Matas": "#3c4b770a",
        "Kicks": "#3c4b770a"
      },
      "hover": {
        "Base": "#0000001a",
        "Matas": "#344d981a",
        "Kicks": "#344d981a"
      },
      "focus": {
        "Base": "#0000001a",
        "Matas": "#344d981a",
        "Kicks": "#344d981a"
      },
      "pressed": {
        "Base": "#00000033",
        "Matas": "#3c4d8133",
        "Kicks": "#3c4d8133"
      },
      "accent": {
        "Base": "#a1a5b2ff",
        "Matas": "#0064feff",
        "Kicks": "#3bd1cdff"
      },
      "highlight": {
        "Base": "#ebecf5ff",
        "Matas": "#daebffff",
        "Kicks": "#cdfaf4ff"
      },
      "info": {
        "Base": "#878b99ff",
        "Matas": "#ebecf5ff",
        "Kicks": "#676973ff"
      },
      "infoLight": {
        "Base": "#f7f8fbff",
        "Matas": "#ebecf5ff",
        "Kicks": "#ebecf5ff"
      },
      "transparent": {
        "Base": "#ffffff00",
        "Matas": "#ffffff00",
        "Kicks": "#ffffff00"
      },
      "success": {
        "Base": "#32852dff",
        "Matas": "#32852dff",
        "Kicks": "#32852dff"
      },
      "successLight": {
        "Base": "#c9ecc6ff",
        "Matas": "#c9ecc6ff",
        "Kicks": "#c9ecc6ff"
      },
      "error": {
        "Base": "#da2828ff",
        "Matas": "#da2828ff",
        "Kicks": "#da2828ff"
      },
      "errorLight": {
        "Base": "#fdcbcbff",
        "Matas": "#fdcbcbff",
        "Kicks": "#fdcbcbff"
      },
      "warning": {
        "Base": "#ae600eff",
        "Matas": "#ae600eff",
        "Kicks": "#ae600eff"
      },
      "warningLight": {
        "Base": "#f7e090ff",
        "Matas": "#f7e090ff",
        "Kicks": "#f7e090ff"
      },
      "subscription": {
        "Base": "#b0b0b0ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "opacityOnDark": {
        "Base": "#ffffff4d",
        "Matas": "#ffffff4d",
        "Kicks": "#ffffff4d"
      },
      "lightGrey": {
        "Base": "#bcc0ccff",
        "Matas": "#d8dbe5ff",
        "Kicks": "#a1a5b2ff"
      },
      "darkGrey": {
        "Base": "#878b99ff",
        "Matas": "#ebecf5ff",
        "Kicks": "#676973ff"
      },
      "neutral": {
        "Base": "#ebecf5ff",
        "Matas": "#676973ff",
        "Kicks": "#ebecf5ff"
      }
    },
    "stateLayer": {
      "default": {
        "hovered": {
          "Base": "#0000001a"
        },
        "onInverseHovered": {
          "Base": "#ffffff1a"
        },
        "pressed": {
          "Base": "#00000033"
        },
        "onInversePressed": {
          "Base": "#ffffff33"
        }
      }
    }
  },
  "typography": {
    "headline": {
      "family": {
        "Base": "DM Sans",
        "Matas": "ES Peak",
        "Kicks": "Maison Neue"
      },
      "weight": {
        "Base": 500,
        "Matas": 600,
        "Kicks": 700
      },
      "3Xl": {
        "Base": 48,
        "Matas": 48,
        "Kicks": 48
      },
      "2Xl": {
        "Base": 40,
        "Matas": 40,
        "Kicks": 40
      },
      "xl": {
        "Base": 32,
        "Matas": 32,
        "Kicks": 32
      },
      "l": {
        "Base": 24,
        "Matas": 24,
        "Kicks": 24
      },
      "m": {
        "Base": 20,
        "Matas": 20,
        "Kicks": 20
      },
      "s": {
        "Base": 18,
        "Matas": 18,
        "Kicks": 18
      }
    },
    "title": {
      "family": {
        "Base": "DM Sans",
        "Matas": "Inter",
        "Kicks": "Maison Neue"
      },
      "weight": {
        "Base": 700,
        "Matas": 600,
        "Kicks": 700
      },
      "l": {
        "Base": 20,
        "Matas": 20,
        "Kicks": 20
      },
      "m": {
        "Base": 18,
        "Matas": 18,
        "Kicks": 18
      },
      "s": {
        "Base": 16,
        "Matas": 16,
        "Kicks": 16
      }
    },
    "link": {
      "family": {
        "Base": "DM Sans",
        "Matas": "Inter",
        "Kicks": "Maison Neue"
      },
      "weightRegular": {
        "Base": 400,
        "Matas": 400,
        "Kicks": 400
      },
      "weightStrong": {
        "Base": 700,
        "Matas": 600,
        "Kicks": 700
      },
      "l": {
        "Base": 16,
        "Matas": 16,
        "Kicks": 16
      },
      "m": {
        "Base": 14,
        "Matas": 14,
        "Kicks": 14
      },
      "s": {
        "Base": 12,
        "Matas": 12,
        "Kicks": 12
      }
    },
    "body": {
      "family": {
        "Base": "DM Sans",
        "Matas": "Inter",
        "Kicks": "Maison Neue"
      },
      "weightRegular": {
        "Base": 400,
        "Matas": 400,
        "Kicks": 400
      },
      "weightStrong": {
        "Base": 700,
        "Matas": 600,
        "Kicks": 700
      },
      "l": {
        "Base": 16,
        "Matas": 16,
        "Kicks": 16
      },
      "m": {
        "Base": 14,
        "Matas": 14,
        "Kicks": 14
      },
      "s": {
        "Base": 12,
        "Matas": 12,
        "Kicks": 12
      }
    },
    "label": {
      "family": {
        "Base": "DM Sans",
        "Matas": "Inter",
        "Kicks": "Maison Neue"
      },
      "weightRegular": {
        "Base": 400,
        "Matas": 400,
        "Kicks": 400
      },
      "weightStrong": {
        "Base": 600,
        "Matas": 600,
        "Kicks": 700
      },
      "l": {
        "Base": 16,
        "Matas": 16,
        "Kicks": 16
      },
      "m": {
        "Base": 14,
        "Matas": 14,
        "Kicks": 14
      },
      "s": {
        "Base": 12,
        "Matas": 12,
        "Kicks": 12
      },
      "xs": {
        "Base": 11,
        "Matas": 11,
        "Kicks": 11
      }
    },
    "overline": {
      "family": {
        "Base": "DM Sans",
        "Matas": "Inter",
        "Kicks": "Maison Neue"
      },
      "weightRegular": {
        "Base": 400,
        "Matas": 400,
        "Kicks": 400
      },
      "m": {
        "Base": 14,
        "Matas": 14,
        "Kicks": 14
      },
      "xSmall": {
        "Base": 11,
        "Matas": 11,
        "Kicks": 11
      }
    },
    "countdown": {
      "family": {
        "Base": "DM Sans",
        "Matas": "Inter",
        "Kicks": "Maison Neue"
      },
      "weight": {
        "Base": 400,
        "Matas": 400,
        "Kicks": 400
      },
      "medium": {
        "Base": 18,
        "Matas": 18,
        "Kicks": 18
      },
      "large": {
        "Base": 48,
        "Matas": 48,
        "Kicks": 48
      }
    },
    "number": {
      "family": {
        "Base": "DM Sans",
        "Matas": "Inter",
        "Kicks": "Maison Neue"
      },
      "weightStrong": {
        "Base": 700,
        "Matas": 600,
        "Kicks": 700
      },
      "pdpPricing": {}
    }
  },
  "spacing": {
    "2": {
      "Base": 2,
      "Matas": 2,
      "Kicks": 2
    },
    "4": {
      "Base": 4,
      "Matas": 4,
      "Kicks": 4
    },
    "6": {
      "Base": 6,
      "Matas": 6,
      "Kicks": 6
    },
    "8": {
      "Base": 8,
      "Matas": 8,
      "Kicks": 8
    },
    "10": {
      "Base": 10,
      "Matas": 10,
      "Kicks": 10
    },
    "12": {
      "Base": 12,
      "Matas": 12,
      "Kicks": 12
    },
    "16": {
      "Base": 16,
      "Matas": 16,
      "Kicks": 16
    },
    "20": {
      "Base": 20,
      "Matas": 20,
      "Kicks": 20
    },
    "24": {
      "Base": 24,
      "Matas": 24,
      "Kicks": 24
    },
    "28": {
      "Base": 28,
      "Matas": 28,
      "Kicks": 28
    },
    "32": {
      "Base": 32,
      "Matas": 32,
      "Kicks": 32
    },
    "36": {
      "Base": 36,
      "Matas": 36,
      "Kicks": 36
    },
    "40": {
      "Base": 40,
      "Matas": 40,
      "Kicks": 40
    },
    "44": {
      "Base": 44,
      "Matas": 44,
      "Kicks": 44
    },
    "48": {
      "Base": 48,
      "Matas": 48,
      "Kicks": 48
    },
    "52": {
      "Base": 52,
      "Matas": 52,
      "Kicks": 52
    },
    "56": {
      "Base": 56,
      "Matas": 56,
      "Kicks": 56
    },
    "64": {
      "Base": 64,
      "Matas": 64,
      "Kicks": 64
    },
    "72": {
      "Base": 72,
      "Matas": 72,
      "Kicks": 72
    },
    "80": {
      "Base": 80,
      "Matas": 80,
      "Kicks": 80
    },
    "88": {
      "Base": 88,
      "Matas": 88,
      "Kicks": 88
    },
    "96": {
      "Base": 96,
      "Matas": 96,
      "Kicks": 96
    },
    "104": {
      "Base": 104,
      "Matas": 104,
      "Kicks": 104
    },
    "128": {
      "Base": 128,
      "Matas": 128,
      "Kicks": 128
    },
    "160": {
      "Base": 160,
      "Matas": 160,
      "Kicks": 160
    },
    "none": {}
  },
  "components": {
    "header": {
      "height": {
        "Base": 120,
        "Matas": 120,
        "Kicks": 120
      },
      "heightDesktop": {
        "Base": 72,
        "Matas": 72,
        "Kicks": 72
      }
    },
    "tooltip": {
      "bg": {
        "primary": {
          "Base": "#084ec5ff",
          "Matas": "#002643ff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Matas": "#d8dbe5ff",
          "Kicks": "#d8dbe5ff"
        }
      }
    },
    "productcard": {
      "color": {
        "overlay": {
          "Base": "#0000000d",
          "Matas": "#3c4b770a",
          "Kicks": "#3c4b770a"
        }
      }
    },
    "cta": {
      "primary": {
        "textDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "iconDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgDefault": {
          "Base": "#084ec5ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bgHover": {
          "Base": "#0d469bff",
          "Matas": "#333436ff",
          "Kicks": "#46484dff"
        },
        "bgFocus": {
          "Base": "#0d469bff",
          "Matas": "#46484dff",
          "Kicks": "#46484dff"
        },
        "bgPressed": {
          "Base": "#0e2b5dff",
          "Matas": "#46484dff",
          "Kicks": "#676973ff"
        },
        "borderDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderHover": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderFocus": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "borderPressed": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        }
      },
      "secondary": {
        "textDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "iconDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bgDefault": {
          "Base": "#0000001a",
          "Matas": "#0026431a",
          "Kicks": "#344d981a"
        },
        "bgHover": {
          "Base": "#00000033",
          "Matas": "#00264333",
          "Kicks": "#3c4d8133"
        },
        "bgFocus": {
          "Base": "#00000033",
          "Matas": "#00264333",
          "Kicks": "#3c4d8133"
        },
        "bgPressed": {
          "Base": "#0000004d",
          "Matas": "#0026434d",
          "Kicks": "#212f574d"
        },
        "borderDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderHover": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderFocus": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderPressed": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        }
      },
      "tertiary": {
        "textDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "iconDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bgDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "bgHover": {
          "Base": "#0000000d",
          "Matas": "#344d981a",
          "Kicks": "#344d981a"
        },
        "bgFocus": {
          "Base": "#0000001a",
          "Matas": "#344d981a",
          "Kicks": "#00000033"
        },
        "bgPressed": {
          "Base": "#0000000d",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        },
        "borderDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "borderHover": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "borderFocus": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "borderPressed": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "ghost": {
        "textDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "iconDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bgDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "bgHover": {
          "Base": "#0000000d",
          "Matas": "#344d981a",
          "Kicks": "#344d981a"
        },
        "bgFocus": {
          "Base": "#00000033",
          "Matas": "#344d981a",
          "Kicks": "#344d981a"
        },
        "bgPressed": {
          "Base": "#0000000d",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        },
        "borderDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderHover": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderFocus": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderPressed": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        }
      },
      "inline": {
        "text": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textHover": {
          "Base": "#00000080",
          "Matas": "#0f1423a3",
          "Kicks": "#0f1423a3"
        },
        "textFocus": {
          "Base": "#000000cc",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textPressed": {
          "Base": "#000000cc",
          "Matas": "#040405cf",
          "Kicks": "#040405cf"
        },
        "borderFocus": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textDisabled": {
          "Base": "#00000066",
          "Matas": "#131d3c66",
          "Kicks": "#131d3c66"
        }
      },
      "elevated": {
        "textDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "iconDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bgDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgHover": {
          "Base": "#ebecf5ff",
          "Matas": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "bgFocus": {
          "Base": "#ebecf5ff",
          "Matas": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "bgPressed": {
          "Base": "#d8dbe5ff",
          "Matas": "#d8dbe5ff",
          "Kicks": "#d8dbe5ff"
        },
        "borderDefault": {
          "Base": "#00000033",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        },
        "borderHover": {
          "Base": "#00000033",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        },
        "borderFocus": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "borderPressed": {
          "Base": "#00000033",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      },
      "inlineSecondary": {
        "text": {
          "Base": "#000000b2",
          "Matas": "#0d0f13c2",
          "Kicks": "#0d0f13c2"
        },
        "bg": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "textHover": {
          "Base": "#000000ff",
          "Matas": "#040405cf",
          "Kicks": "#040405cf"
        },
        "textFocus": {
          "Base": "#000000cc",
          "Matas": "#000000cc",
          "Kicks": "#040405cf"
        },
        "textPressed": {
          "Base": "#000000cc",
          "Matas": "#040507e0",
          "Kicks": "#040507e0"
        },
        "borderFocus": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textDisabled": {
          "Base": "#00000066",
          "Matas": "#131d3c66",
          "Kicks": "#131d3c66"
        }
      },
      "disabled": {
        "textDisabled": {
          "Base": "#00000066",
          "Matas": "#131d3c66",
          "Kicks": "#131d3c66"
        },
        "iconDisabled": {
          "Base": "#0000004d",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        },
        "borderDisabled": {
          "Base": "#00000033",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        },
        "bgDisabled": {
          "Base": "#ebecf5ff",
          "Matas": "#344d981a",
          "Kicks": "#344d981a"
        }
      },
      "primaryInverted": {
        "textDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "iconDefault": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bgDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgHover": {
          "Base": "#ffffffe5",
          "Matas": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "bgFocus": {
          "Base": "#ffffff99",
          "Matas": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "bgPressed": {
          "Base": "#bcc0ccff",
          "Matas": "#bcc0ccff",
          "Kicks": "#bcc0ccff"
        },
        "borderDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderHover": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderFocus": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderPressed": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        }
      },
      "secondaryInverted": {
        "textDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "iconDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgDefault": {
          "Base": "#ffffff1a",
          "Matas": "#ffffff1a",
          "Kicks": "#ffffff1a"
        },
        "bgHover": {
          "Base": "#ffffff33",
          "Matas": "#ffffff33",
          "Kicks": "#ffffff33"
        },
        "bgFocus": {
          "Base": "#ffffff33",
          "Matas": "#ffffff33",
          "Kicks": "#ffffff33"
        },
        "bgPressed": {
          "Base": "#ffffff4d",
          "Matas": "#ffffff4d",
          "Kicks": "#ffffff4d"
        },
        "borderDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderHover": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderFocus": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderPressed": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        }
      },
      "tertiaryInverted": {
        "textDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "iconDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "bgHover": {
          "Base": "#ffffff1a",
          "Matas": "#ffffff1a",
          "Kicks": "#ffffff1a"
        },
        "bgFocus": {
          "Base": "#ffffff33",
          "Matas": "#ffffff1a",
          "Kicks": "#ffffff1a"
        },
        "bgPressed": {
          "Base": "#ffffff33",
          "Matas": "#ffffff33",
          "Kicks": "#ffffff33"
        },
        "borderDefault": {
          "Base": "#ffffff4d",
          "Matas": "#ffffff4d",
          "Kicks": "#ffffffff"
        },
        "borderHover": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "borderFocus": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "borderPressed": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        }
      },
      "ghostInverted": {
        "textDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "iconDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "bgHover": {
          "Base": "#ffffff1a",
          "Matas": "#ffffff1a",
          "Kicks": "#ffffff1a"
        },
        "bgFocus": {
          "Base": "#ffffff33",
          "Matas": "#ffffff1a",
          "Kicks": "#ffffff1a"
        },
        "bgPressed": {
          "Base": "#ffffff1a",
          "Matas": "#ffffff33",
          "Kicks": "#ffffff33"
        },
        "borderDefault": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderHover": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderFocus": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "borderPressed": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        }
      },
      "elevatedInverted": {
        "textDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "iconDefault": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgDefault": {
          "Base": "#000000ff",
          "Matas": "#000000ff",
          "Kicks": "#000000ff"
        },
        "bgHover": {
          "Base": "#202021ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#1a1a1aff"
        },
        "bgFocus": {
          "Base": "#202021ff",
          "Matas": "#202021ff",
          "Kicks": "#202021ff"
        },
        "bgPressed": {
          "Base": "#333436ff",
          "Matas": "#333436ff",
          "Kicks": "#333436ff"
        },
        "borderDefault": {
          "Base": "#ffffff1a",
          "Matas": "#ffffff1a",
          "Kicks": "#ffffff4d"
        },
        "borderHover": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffff4d"
        },
        "borderFocus": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "borderPressed": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffff4d"
        }
      },
      "inlineInverted": {
        "text": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bg": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        },
        "textHover": {
          "Base": "#ffffff80",
          "Matas": "#ffffff80",
          "Kicks": "#ffffff80"
        },
        "textFocus": {
          "Base": "#ffffff80",
          "Matas": "#ffffff80",
          "Kicks": "#ffffff80"
        },
        "textPressed": {
          "Base": "#ffffffcc",
          "Matas": "#ffffffcc",
          "Kicks": "#ffffffcc"
        },
        "borderFocus": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "textDisabled": {
          "Base": "#ffffff4d",
          "Matas": "#ffffff66",
          "Kicks": "#ffffff66"
        }
      },
      "disabledInverted": {
        "textDisabled": {
          "Base": "#ffffff4d",
          "Matas": "#ffffff4d",
          "Kicks": "#ffffff4d"
        },
        "iconDisabled": {
          "Base": "#ffffff4d",
          "Matas": "#ffffff4d",
          "Kicks": "#ffffff4d"
        },
        "bgDisabled": {
          "Base": "#ffffff1a",
          "Matas": "#ffffff1a",
          "Kicks": "#ffffff1a"
        },
        "borderDisabled": {
          "Base": "#ffffff00",
          "Matas": "#ffffff00",
          "Kicks": "#ffffff00"
        }
      },
      "navigation": {
        "text": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bg": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bgHover": {
          "Base": "#d8dbe5ff",
          "Matas": "#d8dbe5ff",
          "Kicks": "#d8dbe5ff"
        },
        "bgFocus": {
          "Base": "#d8dbe5ff",
          "Matas": "#d8dbe5ff",
          "Kicks": "#d8dbe5ff"
        },
        "bgPressed": {
          "Base": "#bcc0ccff",
          "Matas": "#bcc0ccff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "logo": {
      "banner": {
        "Base": "Base",
        "Matas": "Matas",
        "Kicks": "Kicks"
      }
    },
    "label": {
      "fixedPrice": {
        "text": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textInverted": {
          "Base": "#e4803aff",
          "Matas": "#c63b08ff",
          "Kicks": "#c73707ff"
        },
        "bg": {
          "Base": "#efb389ff",
          "Matas": "#ff8326ff",
          "Kicks": "#ff8937ff"
        }
      },
      "sale": {
        "text": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "textInverted": {
          "Base": "#b71e1eff",
          "Matas": "#bd0229ff",
          "Kicks": "#d11616ff"
        },
        "bg": {
          "Base": "#b71e1eff",
          "Matas": "#bd0229ff",
          "Kicks": "#d11616ff"
        }
      },
      "new": {
        "text": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "bg": {
          "Base": "#202021ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#76f96bff"
        }
      },
      "highlight": {
        "text": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#ffffffff"
        },
        "bg": {
          "Base": "#ebecf5ff",
          "Matas": "#ebecf5ff",
          "Kicks": "#161616ff"
        }
      },
      "medicine": {
        "text": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "bg": {
          "Base": "#0d469bff",
          "Matas": "#08009dff",
          "Kicks": "#262f89ff"
        }
      },
      "white": {
        "text": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bg": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        }
      }
    },
    "tag": {
      "campaign": {
        "text": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textInverted": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "bg": {
          "Base": "#d8dbe5ff",
          "Matas": "#d8dbe5ff",
          "Kicks": "#d8dbe5ff"
        }
      },
      "brand": {
        "text": {
          "Kicks": "#ffffffff"
        },
        "textInverted": {
          "Base": "#084ec5ff",
          "Matas": "#002643ff",
          "Kicks": "#161616ff"
        },
        "bg": {
          "Base": "#084ec5ff",
          "Matas": "#002643ff",
          "Kicks": "#161616ff"
        }
      },
      "brandclub1": {
        "text": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textInverted": {
          "Base": "#000000ff",
          "Matas": "#0064feff"
        },
        "bg": {
          "Base": "#bcc0ccff",
          "Matas": "#c5dfffff"
        }
      },
      "brandclub2": {
        "text": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "textInverted": {
          "Base": "#000000ff",
          "Matas": "#795a24ff"
        },
        "bg": {
          "Base": "#a1a5b2ff",
          "Matas": "#d1b98fff"
        }
      }
    },
    "rating": {
      "active": {
        "Base": "#000000ff",
        "Matas": "#1a1a1aff",
        "Kicks": "#161616ff"
      },
      "inactive": {
        "Base": "#0000004d",
        "Matas": "#3c4d8133",
        "Kicks": "#3c4d8133"
      },
      "ratingOption": {
        "Base": "Base ",
        "Matas": "Matas",
        "Kicks": "Kicks"
      }
    }
  },
  "radius": {
    "surface": {
      "none": {},
      "s": {
        "Matas": 4
      },
      "m": {
        "Matas": 8
      },
      "l": {
        "Matas": 16
      },
      "xl": {
        "Matas": 24
      },
      "full": {
        "Base": 999,
        "Matas": 999,
        "Kicks": 999
      }
    },
    "cta": {
      "l": {
        "Matas": 999,
        "Kicks": 999
      },
      "m": {
        "Matas": 8,
        "Kicks": 999
      },
      "s": {
        "Matas": 4,
        "Kicks": 999
      }
    },
    "swatches": {
      "cornerRadius": {
        "Kicks": 999
      }
    }
  },
  "banner": {
    "Base": "Base",
    "Matas": "Matas",
    "Kicks": "Kicks"
  },
  "subThemes": {
    "neutral": {
      "text": {
        "primary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#f7f8fbff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "secondary": {
          "Base": "#0000001a",
          "Matas": "#344d981a",
          "Kicks": "#344d981a"
        }
      },
      "icon": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "border": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#0e183680",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "club1": {
      "text": {
        "primary": {
          "Base": "#1a1a1aff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#b5e4ffff",
          "Matas": "#0064feff",
          "Kicks": "#3bd1cdff"
        },
        "secondary": {
          "Base": "#b5e4ffff",
          "Matas": "#daebffff",
          "Kicks": "#3bd1cdff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "border": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#3285f9ff",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#c5dfffff",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "club2": {
      "text": {
        "primary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#ffffffff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#b5e4ffff",
          "Matas": "#d1b98fff",
          "Kicks": "#3bd1cdff"
        },
        "secondary": {
          "Base": "#b5e4ffff",
          "Matas": "#b38b44ff",
          "Kicks": "#3bd1cdff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#ffffffff"
        }
      },
      "border3": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#795a24ff",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#c2a269ff",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "campaign1": {
      "text": {
        "primary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#ffffffff"
        },
        "secondary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#ffffffff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#b5e4ffff",
          "Matas": "#c5dfffff",
          "Kicks": "#9a43ffff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#ffffffff"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#ffffffff"
        }
      },
      "border4": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#0e183680",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "campaign2": {
      "text": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#1e9affff",
          "Matas": "#0064feff",
          "Kicks": "#f44ab7ff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      },
      "border5": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#0e183680",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "campaign3": {
      "text": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#0066ffff",
          "Matas": "#08009dff",
          "Kicks": "#3bd1cdff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      },
      "border6": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#0e183680",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "sun": {
      "text": {
        "primary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#f7e090ff",
          "Matas": "#fff59bff",
          "Kicks": "#ffd3a8ff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "border7": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#0e183680",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "christmas": {
      "text": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#da2828ff",
          "Matas": "#e40332ff",
          "Kicks": "#ff0000ff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      },
      "border8": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#0e183680",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "blackFriday": {
      "text": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#1a1a1aff",
          "Matas": "#1a1a1aff",
          "Kicks": "#161616ff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#ffffffff"
        }
      },
      "border9": {
        "primary": {
          "Base": "#000000ff",
          "Matas": "#0e183680",
          "Kicks": "#0e183680"
        },
        "secondary": {
          "Base": "#000000ff",
          "Matas": "#3c4d8133",
          "Kicks": "#3c4d8133"
        }
      }
    },
    "pharma": {
      "text": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffff99",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Matas": "#000078ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      },
      "icon": {
        "primary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        },
        "secondary": {
          "Base": "#ffffffff",
          "Matas": "#ffffffff",
          "Kicks": "#161616ff"
        }
      }
    },
    "brandClub1": {
      "icon": {
        "primary": {
          "Base": "#000000ff",
          "Kicks": "#161616ff"
        }
      },
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#bcc0ccff",
          "Kicks": "#a1a5b2ff"
        }
      },
      "components": {
        "cta": {
          "primary": {
            "borderDefault": {
              "Base": "#ffffff00",
              "Matas": "#ffffff00",
              "Kicks": "#ffffff00"
            }
          }
        }
      }
    },
    "brandClub2": {
      "color": {
        "icon": {
          "primary": {
            "Base": "#d8dbe5ff",
            "Kicks": "#161616ff"
          }
        },
        "bg": {
          "primary": {
            "Base": "#ebecf5ff",
            "Kicks": "#ebecf5ff"
          },
          "secondary": {
            "Base": "#bcc0ccff",
            "Kicks": "#a1a5b2ff"
          }
        }
      }
    },
    "sexAndRelationships": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "childrenAndParents": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "advice": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        }
      },
      "border": {
        "primary": {
          "Base": "#ffffff66",
          "Kicks": "#ffffff66"
        }
      }
    },
    "hair": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "skin": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "men": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "fragrance": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "health": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    },
    "makeup": {
      "bg": {
        "primary": {
          "Base": "#ebecf5ff",
          "Kicks": "#ebecf5ff"
        },
        "secondary": {
          "Base": "#d8dbe5ff",
          "Kicks": "#bcc0ccff"
        }
      }
    }
  }
}
